export function getSubmissionFullVersion(productVersion: string, submissionVersion: string) {
	if (!(productVersion || submissionVersion)) {
		return '';
	}

	const outputVersion: string = `${productVersion}.${submissionVersion}`;
	return outputVersion.startsWith('v') ? outputVersion : `v${outputVersion}`;
}

export function sortVersions(a: string, b: string, reversed: boolean = false) {
	if (reversed) {
		return b.localeCompare(a, undefined, { numeric: true });
	}
	return a.localeCompare(b, undefined, { numeric: true });
}
